"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanReadableScore = humanReadableScore;
exports.getResults = getResults;
exports.getScales = getScales;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _rate = _interopRequireDefault(require("../options/rate.json"));

var _able = _interopRequireDefault(require("../options/able.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var likertScale = ["At no time", "Some of the time", "Less than half of the time", "More than half of the time", "Most of the time", "All of the time"];
var batteryId = _utils.screeners.WHO5RTWUS;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "",
  options: likertScale
};
var rtwUsOnboardingQuestions = [{
  prompt: "In the past 2 weeks I have felt cheerful and in good spirits"
}, {
  prompt: "In the past 2 weeks I have felt calm and relaxed"
}, {
  prompt: "In the past 2 weeks I have felt active and vigorous"
}, {
  prompt: "In the past 2 weeks I woke up feeling fresh and rested"
}, {
  prompt: "In the past 2 weeks my daily life has been filled with things that interest me"
}];
var questions = (0, _utils.wrapBattery)(rtwUsOnboardingQuestions, baseProps);
exports.questions = questions;

function humanReadableScore(who5Score) {
  var summaryString = "Very Low";

  if (who5Score > 27) {
    summaryString = "Low";
  }

  if (who5Score > 50) {
    summaryString = "Average";
  }

  if (who5Score > 70) {
    summaryString = "High";
  }

  if (who5Score > 85) {
    summaryString = "Very High";
  }

  return summaryString;
}

function getResults(answers) {
  var who5 = answers.filter(function (a) {
    return typeof a === "number";
  });
  var score = Math.round((0, _sum2["default"])(who5) * 4);
  return {
    WHO5: score,
    WHO_1: answers[0],
    WHO_2: answers[1],
    WHO_3: answers[2],
    WHO_4: answers[3],
    WHO_5: answers[4],
    difficulties: answers[5],
    humanReadable: {
      WHO5: "".concat(score, " (").concat(humanReadableScore(score), ")")
    }
  };
}

function getScales() {
  var scales = {
    WHO5: "Very Low (0-27), Low (28-50), Average (51-70), High (71-85), Very High (86-100)"
  };
  return scales;
}